



























import { Component, Vue, Prop } from 'vue-property-decorator'

import BigAmount from '@/components/BigAmount/BigAmount.vue'

@Component({
  components: {
    BigAmount
  }
})

export default class Table extends Vue {
    @Prop({ required: true, type: String }) cryptocurrencyLabel!: string
    @Prop({ required: true, type: String }) durationLabel!: string
    @Prop({ required: true, type: Number }) percentDifference!: number
    @Prop({ required: true, type: Number }) priceDifference!: number
    @Prop({ required: true, type: Number }) spotPrice!: number
    @Prop({ required: true, type: String }) currency!: string
}
